import * as React from 'react'
import { FC, useEffect } from 'react'
import { useSelector } from 'react-redux'

import { useAppDispatch } from '@user/store/hooks/useAppDispatch'
import { DraftLeadCard } from './Card/DraftLeadCard'
import { NoResultsCard } from '@sales-center/components'
import { selectAllDraftLeads } from '@user/store/draftLeads/slice'
import { updateLoadingState } from '@sales-center/common'
interface Props {
  loading: boolean
  canDelete: boolean
}

export const DraftLeadCardList: FC<Props> = ({ loading, canDelete }) => {
  const dispatch = useAppDispatch()
  const draftLeads = useSelector(selectAllDraftLeads)

  useEffect(() => {
    dispatch(updateLoadingState(loading ? 'visible' : 'hidden'))
  }, [dispatch, loading])

  return draftLeads.length === 0 ? (
    <NoResultsCard label="No pending leads added yet." />
  ) : (
    <>
      {draftLeads.map((l) => (
        <DraftLeadCard canDelete={canDelete} key={l.id} lead={l} />
      ))}
    </>
  )
}

DraftLeadCardList.displayName = 'DraftLeadCardList'
